import React, {useState} from 'react'
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { statusDisponibles } from '../../ComponentsCat/Constantes/constantes';
import { TextoAdvertencia, MensajeAdvertencia } from '../../ComponentsCat/Mensajes/Mensajes';
import useBotones from '../../../../components/hooks/useBotones';

const CrearModificar = ({
    productDialog,
    titulos,
    hideDialog,
    product,
    updateField,
    saveProduct,
    tieneId,
    estiloAP, setEstiloAP,
    estiloAM,setEstiloAM,
    estiloNombre, setEstiloNombre
}) => {
    const listaVigencias = [
        { vigencia: "1 año", value: 1 },
        { vigencia: "2 años", value: 2 },
        { vigencia: "3 años", value: 3 },
        { vigencia: "4 años", value: 4 },
        { vigencia: "5 años", value: 5 },
        { vigencia: "6 años", value: 6 },
        { vigencia: "7 años", value: 7 },
        { vigencia: "8 años", value: 8 },
        { vigencia: "9 años", value: 9 },
        { vigencia: "10 años", value: 10 },
    ]
//--------------------| Validar campos  |--------------------
    const [datosInvalidos, setDatosInvalidos] = useState(false)     // Validar envio
    const [campoInvalido, setCampoInvalido] = useState(false)
    const [mensaje, setMensaje] = useState("")                      // Mensaje para envio
    const [texto, setTexto] = useState("")                          // Mensaje para input
    const expresion=/^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/                   // Acentos y letra 'ñ'
    //--> Validar input
    const ValidarNombre=(texto)=>{
        if (!expresion.test(texto)) {
            setEstiloNombre("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
        }else{
            setEstiloNombre("")
            setTexto("")
            setCampoInvalido(false)
        }
    }

    const enviarDatos = () => {
        if (Object.values(product).includes("")) {
            setMensaje("Todos los campos son obligatorios")
            setDatosInvalidos(true)
            setTimeout(() => { setDatosInvalidos(false) }, 3000)
            return
        }
        else {
            if (campoInvalido) {
                setMensaje("Algún campo no es valido")
                setDatosInvalidos(true)
                setTimeout(() => {setDatosInvalidos(false)}, 3000)
                return
            }
        }
        saveProduct()
    }
    //--> Accion de botones
    const [botones] = useBotones(
        "Cancelar", "pi pi-times", "p-button-rounded", hideDialog,
        "Guardar", "pi pi-check", "p-button-rounded", enviarDatos
    )

//--------------------| Valor que regresara  |--------------------
    return (
        <Dialog
            visible={productDialog} onHide={hideDialog}
            footer={botones} header={titulos.VentanaCrear} 
            style={{ width: '450px' }} modal className="p-fluid" 
        >
            <div className="field">
                <label>Vigencia</label>
                <Dropdown
                    value={product.vigencia} onChange={(e) => updateField(e.value,"vigencia")}
                    options={listaVigencias} optionLabel="vigencia" optionValue="value"
                    placeholder="Selecciona una vigencia" />
            </div>
            {!tieneId && (<div className="field">
                <label>Status</label>
                <Dropdown
                    value={product.idEstatus}
                    options={statusDisponibles} onChange={ e => updateField(e.value, "idEstatus")} 
                    optionLabel="status" placeholder="--Selecciona un status--"
                />
            </div>)}
            <div className='field'>
                <label htmlFor="noUsuarios">NO Usuarios</label>
                <InputNumber
                    inputId="noUsuarios"
                    value={product.noUsuarios} onValueChange={(e) => updateField(e.value,"noUsuarios")} />
            </div>
            <div className='field'>
                <label htmlFor="noMaquinas">NO Maquinas</label>
                <InputNumber
                    inputId="noMaquinas"
                    value={product.noMaquinas} onValueChange={(e) => updateField(e.value,"noMaquinas")} />
            </div>
            <div className="field">
                <label htmlFor="nombrePaquete">Nombre de paquete</label>
                <InputText 
                    id="nombrePaquete"
                    value={product.nombrePaquete}
                    onChange={(e) => {
                        updateField(e.target.value, "nombrePaquete")
                        ValidarNombre(e.target.value)
                    }} 
                    required autoFocus className={estiloNombre} maxLength="25" />
                {estiloNombre && <TextoAdvertencia>{texto}</TextoAdvertencia>}
            </div>
            {datosInvalidos && <MensajeAdvertencia>{mensaje}</MensajeAdvertencia>}
        </Dialog>
    )
}

export default CrearModificar
